import { PHYSICS } from '@push.io/shared';

export type WorldVisualQuality = 'low' | 'medium' | 'high';

export function calculateSpeedRatio(
  vx: number,
  vy: number,
  speedLevel: number,
): number {
  const maximumSpeed = PHYSICS.BASE_SPEED_PER_TICK * (1 + speedLevel * 0.15);
  return Math.max(0, Math.min(1, Math.hypot(vx, vy) / Math.max(0.001, maximumSpeed)));
}
